import './BattleStatGamePad.scss';

import FSDropPanel from "../../1. Core/Controls/DropPanel/FSDropPanel";
import NP from "../../1. Core/NP";
import TopAppBar from "../../1. Core/Controls/TopAppBar/TopAppBar";
import Label from "../../1. Core/Controls/Label/Label";

import Button from "../../1. Core/Controls/Button/Button";
import UserInfo, {IUserInfo} from "../../1. Core/UserInfo";
import Dialog from "../../1. Core/Controls/Dialog/Dialog";
import {ServerAPI} from "../../1. Core/ServerAPI";
import Select from "../../1. Core/Controls/Select/Select";
import {IBattle, MMAEvent, SportType} from "../../10. Battle/types";
import moment = require("moment");
import {ITournament} from "../../10. Battle/Util";
import { EndBoutDialog } from '../EndBoutDialog';

type GamepadAxisValues = { axis: number, value: number }[];

const pressedAxisValue = 0.3; //значение, при котором ось аналога считается нажатой, чем меньше значение, тем больше чувствительность аналогов
const fullPressedAxisValue = 0.8; //значение, при котором ось аналога считается полностью нажатой, чем больше значение, тем меньше нужно отклонить аналог вверх/вниз, чтобы это засчиталось за нажатие диагонали

/**
 * таймаут в милисекундах на запрет повторного ввода, используется чтобы избежать многократного ввода событий при случайном произвольном перемещении аналога
 */
const gamePadInputDenyTimeout = 3000;

interface BattleEditMeta {

	battleId: number,
	isRoundStarted: boolean,
	round?: number,
	isPauseStarted?: boolean,
	pauseLen?: number,
	ground?: boolean,
	grapple?: boolean,
	isRedGrapple?: boolean,
}

export default class BattleStatGamePadKickboxing extends FSDropPanel {
	protected _appBar: TopAppBar;
	protected _gamePadLeftNode: HTMLElement;
	protected _gamePadRightNode: HTMLElement;
	protected _roundTimerNode: HTMLElement;
	protected _roundTimerLbl: Label;
	protected _battleEndDialog: Dialog;
	protected _currentPositionLbl: Label;
	protected _Battle: IBattle;
	protected _leftPadLabels: Label[];
	protected _rightPadLabels: Label[];
	protected _redCurrentEvent: MMAEvent;
	protected _blueCurrentEvent: MMAEvent;
	protected _events: MMAEvent[];
	protected _Round: number;
	protected _redLabel: Label;
	protected _blueLabel: Label;
	protected _historyLabel: Label;
	protected _redActiveButton: Label;
	protected _blueActiveButton: Label;
	protected _Sequence: number;
	protected _nextRound: Button;
	protected _LastEvDate: Date;
	protected _CanClickOneButton: boolean;
	private _ButtonHoldProcessed: boolean; //признак того, что зажатие кнопки обработано в коде
	private _RedGamePadeChecked: number;
	private _BlueGamePadeChecked: number;
	private _CheckEditLockTimer: number;
	private _SendEventsTimer: number;
	private _PressedButtonChecked: number;
	private _RoundStarted: number;
	private _RefreshRoundTimer: number;
	private _GrappleStarted: string;
	private _isRedGrappleStarted: boolean;
	private _GroundStarted: string;
	private _RedCurrentEventState: number;  //1 - hit, 2 - zone, 3 - answer/grapple/ground
	private _BlueCurrentEventState: number;  //1 - hit, 2 - zone, 3 - answer/grapple/ground
	private _CurrentPosition: string;
	private _IsPause: boolean;
	private _PauseStarted: number;
	private _PauseLength: number;

	/**
	 * пока true новое событие submission не создается
	 */
	private _IsSubmissionTimeoutActive: boolean;
	private _urlId: string;

	constructor(settings: object)
	{
		super(settings);
	}

	_initFields(settings: object)
	{
		this._Battle = null;
		this._events = [];
		this._Round = 1;
		this._Sequence = 1;
		this._CheckEditLockTimer = null;
		this._SendEventsTimer = null;
		this._PressedButtonChecked = null;
		this._ButtonHoldProcessed = false;
		this._RedCurrentEventState = 1;
		this._BlueCurrentEventState = 1;
		this._CurrentPosition = 'Distance';
		this._CanClickOneButton = true;
		this._IsPause = false;
		this._PauseLength = 0;
		super._initFields(settings);
		this._AutoDestroy = false;
	}

	_render()
	{

		super._render();
		this.addClass('game-pad-dropdown');

		this._contentDomNode.classList.add('dropdown__content--flex');

		this._appBar = new TopAppBar({
			Class: 'top-app-bar--white',
			Caption: NP.RM.getString('BattleStatistics'),
			ShowSearchButton: false,
			// MainButton: {
			// 	FontImage: NP.FontImages.close,
			// 	EvClick: () =>
			// 	{
			// 		this.trySendMeta({battleId: this._Battle.Id, isRoundStarted: false}, 3, () => this.hide())
			// 	}
			// },
			RightItems: [
				new Button({
					RK: 'Hide Game pads',
					Value: true,
					EvClick: (btn: Button) => this.switchVisiblePads(btn)
				}),
				this._nextRound = new Button({
					Content: NP.RM.getString('NextRound') + ' ' + this._Round,
					EvClick: () => this.nextRound()
				}),
				new Button({
					RK: 'BoutEnd',
					EvClick: () => this.endBattle()
				})]
		});

		this._appBar.showWaiter = () =>
		{
			//чтобы ui не блокировался случайно
		}


		this._appBar.putToNode(this._root, this._contentDomNode);

		this._gamePadLeftNode = NP.createNode(this._contentDomNode, 'game-pad__left-node');
		this._redLabel = new Label({
			Content: this._Battle.RedName + ` (${NP.RM.getString('Red')})`,
			ParentNode: this._gamePadLeftNode,
			Class: 'game-pad__red-label'
		});
		NP.createNode(this._gamePadLeftNode, 'game-pad__left-node__img-node');
		this._leftPadLabels = this._createLabels(this._gamePadLeftNode, true);

		this._historyLabel = new Label({
			ParentNode: this._contentDomNode,
			Class: 'game-pad__history game-pad__history--timer'
		});

		this._gamePadRightNode = NP.createNode(this._contentDomNode, 'game-pad__right-node');
		this._blueLabel = new Label({
			Content: this._Battle.BlueName + ` (${NP.RM.getString('Blue')})`,
			ParentNode: this._gamePadRightNode,
			Class: 'game-pad__blue-label'
		});
		NP.createNode(this._gamePadRightNode, 'game-pad__right-node__img-node');

		this._roundTimerNode = NP.createNode(this._contentDomNode, 'round-timer');
		this._roundTimerLbl = new Label({
			ParentNode: this._roundTimerNode,
			Class: 'round-timer__lbl'
		});
		this._currentPositionLbl = new Label({
			ParentNode: this._roundTimerNode,
			Class: 'round-timer__lbl'
		});

		this._rightPadLabels = this._createLabels(this._gamePadRightNode, false);

		this.updateStatus();
	}

	_refreshRoundTimer()
	{
		if (!this._IsPause)
		{
			this._roundTimerLbl.setContent(this.getFormattedCurrentRoundTime());
			this._currentPositionLbl.removeClass('round-timer__lbl--red');
			this._currentPositionLbl.removeClass('round-timer__lbl--blue');
			this._currentPositionLbl.setContent(NP.RM.getString(this._CurrentPosition) + (this._GrappleStarted ? ` (${NP.RM.getString('Control')})` : ''));
			if (this._GrappleStarted)
				this._currentPositionLbl.addClass(this._isRedGrappleStarted ? 'round-timer__lbl--red' : 'round-timer__lbl--blue');
		}
	}

	setWidth(w: number)
	{
		super.setWidth(w);
		if (this._appBar)
			NP.setIsVisible(this._appBar.getRightItems(), w > 300)
	}

	getFormattedCurrentRoundTime()
	{
		let roundTimeSec = 0,
			 roundTimeMin = 0;
		if (this._RoundStarted)
		{
			let roundTimeMillis = this.getRoundTimeMillis();
			roundTimeSec = Math.round(roundTimeMillis / 1000);
			roundTimeMin = Math.floor(roundTimeSec / 60);
		}
		let sec = roundTimeMin ? roundTimeSec % (roundTimeMin * 60) : roundTimeSec,
			 displayMin = roundTimeMin < 10 ? '0' + roundTimeMin : '' + roundTimeMin,
			 displaySec = sec < 10 ? '0' + sec : '' + sec;

		if (roundTimeMin >= this._Battle.RoundLength)
		{
			return (this._Battle.RoundLength < 10 ? '0' + this._Battle.RoundLength : '' + this._Battle.RoundLength) + ':00';
		}

		return displayMin + ':' + displaySec;
	}

	getFormattedBattleTotalTime()
	{
		let maxBattleTimeSec = 60 * this._Battle.RoundLength * this._Round,
			 battleTimeSec = 60 * this._Battle.RoundLength * (this._Round - 1);
		if (this._RoundStarted)
			battleTimeSec += Math.floor(this.getRoundTimeMillis() / 1000);
		if (battleTimeSec > maxBattleTimeSec)
			battleTimeSec = maxBattleTimeSec;

		let battleTimeMin = Math.floor(battleTimeSec / 60);

		let sec = battleTimeMin ? battleTimeSec % (battleTimeMin * 60) : battleTimeSec,
			 displayMin = battleTimeMin < 10 ? '0' + battleTimeMin : '' + battleTimeMin,
			 displaySec = sec < 10 ? '0' + sec : '' + sec;

		return '00:' + displayMin + ':' + displaySec;
	}

	getRoundTimeMillis()
	{
		return (new Date).getTime() - this._RoundStarted - this._PauseLength;
	}

	showBlockDialog(blockerSettings: IUserInfo)
	{

		if (!blockerSettings)
			return false;

		let blocker: UserInfo = new UserInfo(blockerSettings);
		let curUser = NP.getCurrentUser();
		let isYou = curUser.getKey() === blocker.getKey();
		let emailPart = !isYou ? NP.escapeHTML(`<${blocker.getEmail()}>`) : '';
		let unlockPart = isYou ? `<br />${NP.RM.getString('UnlockQuestion')}` : '';
		let dlg = new Dialog({
			ShowHeader: true,
			Caption: NP.RM.getString('Error'),
			Content: `${NP.RM.getString('BattleLockMessage')}${blocker.getViewName()}${emailPart}${unlockPart}`,
			AutoDestroy: true,
			ShowButtons: true,
			EvOkButtonClick: isYou ? this.onBlockDialogOkButtonClick : undefined,
		});
		if (!isYou)
			dlg.getCancelButton().setIsVisible(false);
		dlg.show();
		return true;
	}

	showBattleEndDialog(round: number, okCallback: Function)
	{
		this._Battle.EndTime = this.getFormattedBattleTotalTime();
		ServerAPI.post(`/battle/${this._Battle.Id}/updateEndTimeBattle?endTime=${this.getFormattedBattleTotalTime()}`);

		this._battleEndDialog = new Dialog({
			ShowHeader: false,
			Content: NP.RM.getString('EndBattleMessage'),
		});
		this._battleEndDialog.getOkButton().destroy();
		this._battleEndDialog.getCancelButton().destroy();

		this._battleEndDialog.getTopAppBar().showWaiter = () =>
		{
			//чтобы ui не блокировался случайно
		}

		new Button({
			Class: 'dialog__button dialog__action float-left-btn',
			ParentNode: this._battleEndDialog.getButtonsNode(),
			RK: 'Cancel',
			EvClick: () =>
			{
				this._Battle.EndTime = null;
				ServerAPI.post(`/battle/${this._Battle.Id}/updateEndTimeBattle`);
				this._battleEndDialog.hide()
			}
		});

		new Button({
			Class: 'dialog__button dialog__action',
			ParentNode: this._battleEndDialog.getButtonsNode(),
			RK: 'Round',
			EvClick: () =>
			{
				this._Battle.EndTime = null;
				this._battleEndDialog.hide();
				ServerAPI.post(`/battle/${this._Battle.Id}/updateEndTimeBattle`)
				okCallback();
			}
		});

		new Button({
			Class: 'dialog__button dialog__action',
			ParentNode: this._battleEndDialog.getButtonsNode(),
			RK: 'Bout',
			EvClick: () =>
			{
				okCallback();
				this._onEndBattleConfirm(round)
			}
		});

		this._battleEndDialog.show();
	}

	onBlockDialogOkButtonClick = () =>
	{
		ServerAPI.post(`/battle/${this._Battle.Id}/endEditBattleData`).then(() =>
		{
			NP.editingBattleId = null;
			this.show();
		});
		window.clearInterval(this._CheckEditLockTimer);
	}

	show(left?: number, top?: number, notCreateFrame?: boolean, skipConfirm?: boolean)
	{
		if (!skipConfirm)
		{


			let dlg = new Dialog({
				Content: [
					new Label({RK: 'IsGlobal'}),
					new Select({
						Items: [
							{RK: 'No', Value: ''},
							{Content: 'Current', Value: 'current'},
							{Content: 'Current2', Value: 'current2'},
							{Content: 'currentBellator', Value: 'currentBellator'},
							{Content: 'currentKSW', Value: 'currentKSW'},
							{Content: 'currentGlory', Value: 'currentGlory'},
							{Content: 'currentRizin', Value: 'currentRizin'},
							{Content: 'currentMMASeries', Value: 'currentMMASeries'},
							{Content: 'currentNaizaFC', Value: 'currentNaizaFC'},
							{Content: 'currentCageWarriors', Value: 'currentCageWarriors'},
							{Content: 'currentLFA', Value: 'currentLFA'},
							{Content: 'currentJCK', Value: 'currentJCK'},
							{Content: 'currentKarateCombat', Value: 'currentKarateCombat'},
							{Content: 'currentGOF', Value: 'currentGOF'},
							{Content: 'currentSS', Value: 'currentSS'},
							{Content: 'currentRCC', Value: 'currentRCC'},
							{Content: 'currentEternal', Value: 'currentEternal'},
						]
					})
				],
				EvOkButtonClick: () =>
				{

					let value = dlg.getContent()[1].getValue();
					if (value)
					{
						this._urlId = value;
						this.show(left, top, notCreateFrame, true);
					}
					else
					{
						super.show();
						this.startInputData();
					}
				}
			});

			dlg.show();
			dlg.getCancelButton().setIsVisible(false);

			if (this._Battle.EventId)
			{
				ServerAPI.get<ITournament[]>(`/tournaments`).then(ev =>
				{
					let select = dlg.getContent()[1]
					let t = ev.find(t => t.Id == this._Battle.TournamentId);
					if (t?.Current) {
						if (!select.getItems().find(it => it.Value == t.Current))
						{
							select.addItem({Content: t.Current, Value: t.Current})
						}
						select.setValue(t?.Current)
					}
				})
			}

			return true;
		}


		ServerAPI.post(`/battle/${this._Battle.Id}/startEditBattleData?url=${this._urlId}`).then(() =>
		{
			super.show();
			this.startInputData();
		// 	if (this.showBlockDialog(blocker))
		// 		return;
		//
		// 	const checkInterval = 10000;
		// 	NP.editingBattleId = this._Battle.Id;
		// 	super.show();
		//
		// 	if (this._CheckEditLockTimer != null)
		// 		window.clearInterval(this._CheckEditLockTimer);
		// 	this._CheckEditLockTimer = window.setInterval(() =>
		// 	{
		// 		ServerAPI.post(`/battle/${this._Battle.Id}/checkIsBattleDataLocked?url=${this._urlId}`).then((isLocked: boolean) =>
		// 		{
		// 			if (!isLocked)
		// 			{
		// 				ServerAPI.post(`/battle/${this._Battle.Id}/startEditBattleData?url=${this._urlId}`)
		// 			}
		// 		});
		// 	}, checkInterval);
		//
		// 	this.startInputData();
		//
		 });
		return true;
	}

	startInputData()
	{
		this.setWidth(this._Width);
		let current = this._urlId || '';
		this._appBar.getCaptionNode().innerHTML = `${current}<br/> <span style="color:${NP.RED_COLOR}"> ${this._Battle.RedName} </span> vs <span style="color:${NP.BLUE_COLOR}"> ${this._Battle.BlueName}</span>`


		const saveInterval = 1000;
		if (this._SendEventsTimer != null)
			window.clearInterval(this._SendEventsTimer);
		this._SendEventsTimer = window.setInterval(() => this.sendCurrentEvents(), saveInterval);

		const refreshRoundTimerInterval = 1000;
		if (this._RefreshRoundTimer != null)
			window.clearInterval(this._RefreshRoundTimer);
		this._RefreshRoundTimer = window.setInterval(() => this._refreshRoundTimer(), refreshRoundTimerInterval);
		this._refreshRoundTimer();
	}

	hide()
	{
		ServerAPI.post(`/battle/${this._Battle.Id}/endEditBattleData`).then(() =>
		{
			NP.editingBattleId = null;
		});
		window.clearInterval(this._CheckEditLockTimer);
		window.clearInterval(this._RefreshRoundTimer);
		super.hide();
	}

	switchVisiblePads(btn: Button)
	{
		if (btn.getValue())
		{
			btn.setValue(false);
			btn.setRK('Show Game pads');
			this._gamePadLeftNode.style.height = '30px';
			this._gamePadRightNode.style.height = '30px';
		}
		else
		{
			btn.setValue(true);
			btn.setRK('Hide Game pads');
			this._gamePadLeftNode.style.height = '';
			this._gamePadRightNode.style.height = '';
		}
	}


	async trySendMeta(payload: BattleEditMeta, attemptsCount?: number, callback?: Function)
	{
		if (attemptsCount == undefined)
			attemptsCount = 1;

		if (attemptsCount > 0)
		{
			attemptsCount -= 1;
			await ServerAPI.post("/mma/setBattleEditMeta", payload)
				 .then(() => callback && callback())
				 .catch(() => this.trySendMeta(payload, attemptsCount, callback));
		}
	}

	sendCurrentEvents(clear?: boolean, callback?: Function)
	{
		if (this._events)
		{
			let eventsToSend: MMAEvent[] = [];
			this._events.forEach(ev =>
			{
				if (!ev.IsSaved)
					if (ev.Action && ev.Zone && ev.Answer || (ev.Action == 'Takedown' || ev.Action == 'Transition' || ev.Action == 'Control'))
					{
						ev.IsSaved = true;
						eventsToSend.push(Object.assign({}, ev));
					}
			});

			if (clear)
				this._events = [];

			if (eventsToSend.length > 0)
			{
				let subHits = [] as MMAEvent[];
				eventsToSend.forEach(ev =>
				{
					if (ev.GroundStart)
						ev.GroundStart = '00:' + ev.GroundStart;
					if (ev.GroundEnd)
						ev.GroundEnd = '00:' + ev.GroundEnd;
					if (ev.GrappleStart)
						ev.GrappleStart = '00:' + ev.GrappleStart;
					if (ev.GrappleEnd)
						ev.GrappleEnd = '00:' + ev.GrappleEnd;

					if (ev.Action == 'Submission' && ev.Answer == 'Hit')
					{
						subHits.push(ev);
					}
				});


				if (subHits.length > 1)
					NP.removeFromArray(eventsToSend, subHits[subHits.length - 1]);


				ServerAPI.post(`/mma/${this._Battle.Id}/addBattleEvents`, eventsToSend)
					 .then(() => callback && callback())
			}
			else
				callback && callback();
		}
		else
			callback && callback();
	}

	endBattle()
	{
		this._Battle.EndTime = this.getFormattedBattleTotalTime();

		this.sendCurrentEvents(true, () =>
		{
			if (this._GroundStarted)
				this._endGround();
			else if (this._GrappleStarted)
				this._endGrapple();

			this.trySendMeta({
				battleId: this._Battle.Id,
				isRoundStarted: false
			}, 3, () => this._onEndBattleConfirm(this._Round));
		});
	}

	async _onEndBattleConfirm(round: number)  //текущий раунд передается аргументом, потому что он может быть асинхронно инкрементирован
	{
		this._Battle.WinRound = round;
		(new EndBoutDialog({
			Battle: this._Battle,
			LastEvent: this._events[this._events.length - 1],
			EndTimeStr: this._Battle.EndTime,
			EvOkButtonClick: () => {
				ServerAPI.post(`/mma/fixEndBattleData/${this._Battle.Id}`)
				this.hide()
				NP.showMessage({Content: NP.RM.getString('BoutEndMsg')});
			}
		})).show();


		// await ServerAPI.post(`/battle/${this._Battle.Id}`, {
		// 	...this._Battle,
		// 	Status: 'Finished',
		// 	RoundCount: round,
		// 	Date: this._Battle.Date ? moment(this._Battle.Date).format('YYYY-MM-DD HH:mm:ss.S') : null
		// }).then(() =>
		// {
		// 	NP.showMessage({Content: NP.RM.getString('BoutEndMsg')});
		// });
		//
		//
	}

	_resetEventState(isRed?: boolean)
	{
		if (isRed || isRed == undefined)
		{
			this._redCurrentEvent = null;
			this._RedCurrentEventState = 1;
		}

		if (!isRed)
		{
			this._blueCurrentEvent = null;
			this._BlueCurrentEventState = 1;
		}
	}

	nextRound()
	{
		if (this._events.find(ev => ev.Round == this._Round))
		{
			this.showBattleEndDialog(this._Round, () =>
			{
				if (!this._Battle.EndTime)
					this._Battle.EndTime = this.getFormattedBattleTotalTime();

				this.sendCurrentEvents(true, () =>
				{
					if (this._GroundStarted)
						this._endGround();
					else if (this._GrappleStarted)
						this._endGrapple();


					this._resetEventState();
					this._RoundStarted = null;
					this._PauseLength = 0;
					this._historyLabel.setContent('');

					this._refreshRoundTimer();

					this.trySendMeta({battleId: this._Battle.Id, isRoundStarted: false}, 3, () =>
					{
						this._Round++;
						this._nextRound.setContent(NP.RM.getString('NextRound') + ' ' + this._Round);
					});
				});
			});
		}
	}

	_createLabels(gamePadNode: HTMLElement, isRed: boolean)
	{
		let res = [
			//Cross
			new Label({
				RK: 'Knee',
				Value: 0,
				Data: 'IsAction'
			}),
			//Circle
			new Label({
				RK: 'Kick',
				Value: 1,
				Data: 'IsAction'
			}),
			//Square
			new Label({
				RK: 'Jeb',
				Value: 2,
				Data: 'IsAction'
			}),
			//Triangle
			new Label({
				RK: 'Cross',
				Value: 3,
				Data: 'IsAction',
			}),

			//L1
			new Label({
				Value: 7,
				RK: 'UR',
				Data: 'IsAction'
			}),
			//R1
			new Label({
				Value: 5,
				RK: 'HR',
				Data: 'IsAction'
			}),
			//L2
			new Label({
				Value: 6,
				RK: 'UL',
				Data: 'IsAction'
			}),
			//R2
			new Label({
				Value: 4,
				RK: 'HL',
				Data: 'IsAction'
			}),

			//Select
			new Label({
				RK: 'SelectLbl',
				Value: 8
			}),

			//Start
			new Label({
				RK: 'StartLbl',
				Value: 9
			}),

			//Left stick press
			new Label({
				RK: 'Control',
				Value: 10,
				Content: '+Control',
				Data: 'Control'
			}),
			//Right stick press
			new Label({
				RK: 'Ground',
				Value: 11,
				Content: '+Ground',
				Data: 'Ground'
			}),

			//up
			new Label({
				RK: 'Slip',
				Value: 12,
				Data: 'IsAnswer'
			}),
			//down
			new Label({
				RK: 'Hit',
				Value: 13,
				Data: 'IsAnswer'
			}),
			//left
			new Label({
				RK: 'Footwork',
				Value: 14,
				Data: 'IsAnswer'
			}),
			//right
			new Label({
				RK: 'Block',
				Value: 15,
				Data: 'IsAnswer'
			}),

			//болевые
			//Left stick left
			new Label({
				RK: 'P3',
				Value: [{axis: 0, value: -1}],
				Content: 'P3',
				Tag: 'sub',
				Data: 'IsSubmission'
			}),
			//Left stick right
			new Label({
				RK: 'P4',
				Value: [{axis: 0, value: 1}],
				Content: 'P4',
				Tag: 'sub',
				Data: 'IsSubmission'
			}),
			//Left stick up
			new Label({
				RK: 'P1',
				Value: [{axis: 1, value: -1}],
				Content: 'P1',
				Tag: 'sub',
				Data: 'IsSubmission'
			}),
			//Left stick down-left
			new Label({
				RK: 'P5',
				Value: [{axis: 0, value: -1}, {axis: 1, value: 1}],
				Content: 'P5',
				Tag: 'sub',
				Data: 'IsSubmission'
			}),
			//Left stick down-right
			new Label({
				RK: 'P6',
				Value: [{axis: 0, value: 1}, {axis: 1, value: 1}],
				Content: 'P6',
				Tag: 'sub',
				Data: 'IsSubmission'
			}),

			//попадания
			//Right stick left
			new Label({
				RK: 'P2',
				Value: [{axis: 2, value: -1}],
				Content: 'P2',
				Tag: 'left',
				Data: 'IsZone'
			}),
			//Right stick right
			new Label({
				RK: 'P2',
				Value: [{axis: 2, value: 1}],
				Content: 'P2',
				Tag: 'right',
				Data: 'IsZone'
			}),
			//Right stick up
			new Label({
				RK: 'P1',
				Value: [{axis: 3, value: -1}],
				Content: 'P1',
				Data: 'IsZone'
			}),
			//Right stick down-left
			new Label({
				RK: 'P5',
				Value: [{axis: 2, value: -1}, {axis: 3, value: 1}],
				Content: 'P5',
				Data: 'IsZone'
			}),
			//Right stick down-right
			new Label({
				RK: 'P6',
				Value: [{axis: 2, value: 1}, {axis: 3, value: 1}],
				Content: 'P6',
				Data: 'IsZone'
			}),
		];

		res.forEach(lbl =>
		{
			let labelTxt = lbl.getRK() || lbl.getContent();
			lbl.addClass('game-pad__' + labelTxt
				 + (labelTxt.substr(0, 2).match(/P\d/i) ? '-mma' : '')
				 + (lbl.getTag() ? '--' + lbl.getTag() : ''));

			lbl.putToNode(gamePadNode);
			lbl.EvClick.add((sender: Label) =>
			{
				this._onGamePadClick(null, sender, isRed);
			}, this);
		});

		const c = res.find(l => l.getRK() == 'Cross')

		c.getRoot().style.left = '478px'
		c.getRoot().style.top = '132px'


		const j = res.find(l => l.getRK() == 'Jeb')

		j.getRoot().style.left = '428px'
		j.getRoot().style.top = '180px'

		return res;
	}

	vibrate(gamepad: any)
	{
		if (gamepad)
			gamepad.vibrationActuator.playEffect("dual-rumble", {duration: 100, strongMagnitude: 1.0, weakMagnitude: 1.0});

		console.log('vibrate')
	}

	vibrateAll()
	{
		for (let gamepad of navigator.getGamepads())
		{
			if (gamepad && gamepad.id.indexOf('Xbox') > -1)
				(gamepad as any).vibrationActuator.playEffect("dual-rumble", {
					duration: 100,
					strongMagnitude: 1.0,
					weakMagnitude: 1.0
				});
		}
	}

	updateHistory()
	{
		this._historyLabel.setContent('');
		if (this._events.length)
		{
			let groundStartDisplayed = false,
				 grappleStartDisplayed = false,
				 groundEnd = null,
				 grappleEnd = null;

			for (let ev of this._events)
			{
				if (ev.Round != this._Round)
					continue;
				let res = '',
					 historyRowClass = ev.ActionAthleteId == this._Battle.Red ? 'game-pad__history-row--red' : 'game-pad__history-row--blue';

				//метка начала партера
				if (ev.GroundStart && !groundStartDisplayed)
				{
					groundStartDisplayed = true;
					let span = NP.createNode(this._historyLabel.getRoot());
					span.innerText = 'G+' + ev.GroundStart;
				}

				//метка начала удержания
				if (ev.GrappleStart && !grappleStartDisplayed)
				{
					grappleStartDisplayed = true;
					let span = NP.createNode(this._historyLabel.getRoot());
					span.innerText = 'C+' + ev.GrappleStart;
				}

				//метка окончания удержания
				if (grappleStartDisplayed && !ev.GrappleStart && grappleEnd)
				{
					grappleStartDisplayed = false;
					let span = NP.createNode(this._historyLabel.getRoot());
					span.innerText = 'C-' + grappleEnd;
				}

				//метка окончания партера
				if (groundStartDisplayed && !ev.GroundStart && groundEnd)
				{
					groundStartDisplayed = false;
					let span = NP.createNode(this._historyLabel.getRoot());
					span.innerText = 'G-' + groundEnd;
				}

				res += ev.Action.substr(0, 3);
				if (ev.Zone)
					res += '     ' + ev.Zone.substr(0, 3);
				else
					res += '     ' + "_";
				if (ev.Answer)
					res += '     ' + ev.Answer.substr(0, 3);
				else
					res += '     ' + "_";
				let span = NP.createNode(this._historyLabel.getRoot(), historyRowClass);
				span.innerText = res;

				groundEnd = ev.GroundEnd;
				grappleEnd = ev.GrappleEnd;
			}

			//метка окончания удержания, если выход из удержания был на последнем событии
			if (grappleStartDisplayed && this._events[this._events.length - 1].GrappleEnd)
			{
				let span = NP.createNode(this._historyLabel.getRoot());
				span.innerText = 'C-' + this._events[this._events.length - 1].GrappleEnd;
			}

			//метка окончания партера, если выход из партера был на последнем событии
			if (groundStartDisplayed && this._events[this._events.length - 1].GroundEnd)
			{
				let span = NP.createNode(this._historyLabel.getRoot());
				span.innerText = 'G-' + this._events[this._events.length - 1].GroundEnd;
			}

			this._historyLabel.getRoot().scrollTop = this._historyLabel.getRoot().scrollHeight;
		}
	}

	_onGamePadClick(gamepad: Gamepad, label: Label, isRed: boolean)
	{
		let actionId = label.getRK() || label.getContent();

		if (this._IsPause && actionId != 'SelectLbl')
			return this.vibrate(gamepad);

		if (actionId == 'SelectLbl')
		{
			this._onPauseClick();
			return;
		}

		if (actionId == 'StartLbl')
		{
			if (!this._RoundStarted)
				this.startRound();
			else
				this.nextRound();
			return;
		}
		else if (!this._RoundStarted)
		{
			return this.vibrate(gamepad);
		}

		if (this._LastEvDate == null)
			this._LastEvDate = new Date();

		switch (label.getData())
		{
			case 'IsAction':
				this._onActionClick(this._getEventByAthlete(isRed), actionId, gamepad, false, isRed);
				break;
			case 'IsZone':
				this._onZoneClick(actionId, gamepad, isRed);
				break;
			case 'IsAnswer':
				this._onAnswerClick(actionId, gamepad, isRed);
				break;
			case 'IsSubmission':
				this._onSubmissionClick(this._getEventByAthlete(isRed), actionId, false, gamepad, isRed);
				break;
			case 'IsTakedownMiss':
			case 'IsTakedownSuccess':
				this._onTakedownClick(this._getEventByAthlete(isRed), actionId, label.getData() == 'IsTakedownSuccess', gamepad, isRed);
				break;
			case 'Ground':
				this._onGroundClick(gamepad, isRed);
				break;
			case 'Control':
				this._onControlClick(this._getEventByAthlete(isRed), label, gamepad, isRed);
				break;
		}
	}

	_onGamePadHold(gamepad: Gamepad, label: Label, isRed: boolean)
	{
		let actionId = label.getRK();

		if (!this._ButtonHoldProcessed)
		{
			this._ButtonHoldProcessed = true;

			switch (label.getData())
			{
				case 'IsAction':
					this._onActionClick(this._getEventByAthlete(isRed), actionId, gamepad, true, isRed);
					break;
				case 'IsZone':
					this._onKnockdownClick(actionId, gamepad, isRed);
					break;
				case 'IsSubmission':
					this._onSubmissionClick(this._getEventByAthlete(isRed), actionId, true, gamepad, isRed);
					break;
			}
			return;
		}
	}

	_addMMAEvent(ev: MMAEvent)
	{
		this._setEventGroundGrapple(ev);

		ev.ActionTS = moment().utc().format('YYYY-MM-DD HH:mm:ss.S');   //важно чтобы время на сервере и на клиенте совпадало
		ev.Time = '00:' + this.getFormattedCurrentRoundTime();

		this._events.push(ev);
	}

	_setEventGroundGrapple(ev: MMAEvent)
	{
		if (this._GroundStarted)
			ev.GroundStart = this._GroundStarted;
		if (this._GrappleStarted)
			ev.GrappleStart = this._GrappleStarted;
	}

	_onPauseClick()
	{
		if (this._IsPause)
		{
			this._IsPause = false;
			this._PauseLength += (new Date()).getTime() - this._PauseStarted;
			this._PauseStarted = null;
		}
		else
		{
			this._IsPause = true;
			this._PauseStarted = (new Date).getTime();
		}

		this.trySendMeta(this.getBattleEditMeta(), 3);
	}

	_onActionClick(ev: MMAEvent, actionId: string, gamepad: Gamepad, isCritical: boolean, isRed: boolean)
	{
		if (isRed && (this._RedCurrentEventState == 1 || isCritical)
			 || !isRed && (this._BlueCurrentEventState == 1 || isCritical))
		{
			//isCritical - значит кнопка удерживается, событие уже должно быть добавлено ранее при нажатии этой же кнопки, его нужно отредактировать как Critical
			if (isCritical && this._events.length)
			{
				let lastEvent = this._findLastEventByAthlete(isRed);
				if (lastEvent)
					lastEvent.Answer = 'CriticalPunch';
			}
			else
			{
				ev.Action = actionId;
				this._addMMAEvent(ev);
				if (isRed)
					this._RedCurrentEventState = 2;
				else
					this._BlueCurrentEventState = 2;
			}
			this.updateHistory();
		}
		else
		{
			this.vibrate(gamepad);
		}
	}

	_onSubmissionClick(ev: MMAEvent, actionId: string, isSuccess: boolean, gamepad: Gamepad, isRed: boolean)
	{
		if (isRed && this._RedCurrentEventState == 1 || !isRed && this._BlueCurrentEventState == 1)
		{

			if (this._Battle.Type == SportType.KB && isSuccess)
				isSuccess = false;

			//isSuccess - значит кнопка удерживается, событие уже должно быть добавлено ранее при нажатии этой же кнопки
			//нужно отредактировать последнее событие в БД так как оно уже сохранилось в течение 1 сек.
			if (isSuccess)
			{
				let lastEvent = this._findLastEventByAthlete(isRed);
				if (lastEvent)
				{
					lastEvent.Answer = 'Hit';
					ServerAPI.post(`/mma/editLastEvent/${this._Battle.Id}?round=${this._Round}`, lastEvent)
						 .then(() => this.endBattle());
				}
			}
			else if (this._IsSubmissionTimeoutActive)
				this.vibrate(gamepad);
			else
			{
				this._IsSubmissionTimeoutActive = true;
				setTimeout(() => this._IsSubmissionTimeoutActive = false, gamePadInputDenyTimeout);

				ev.Action = 'Submission';
				ev.Zone = actionId;
				ev.Answer = 'Miss';
				this._addMMAEvent(ev);
				this.updateHistory();
			}
		}
		else
		{
			this.vibrate(gamepad);
		}
	}

	_onZoneClick(actionId: string, gamepad: Gamepad, isRed: boolean)
	{
		if (this._events.length
			 && (isRed && this._RedCurrentEventState == 2 || !isRed && this._BlueCurrentEventState == 2))
		{
			let lastEvent = this._findLastEventByAthlete(isRed);
			if (lastEvent)
			{
				lastEvent.Zone = actionId;

				if (lastEvent.Answer == 'CriticalPunch')
					this._resetEventState(isRed);
				else
				{
					if (isRed)
						this._RedCurrentEventState = 3;
					else
						this._BlueCurrentEventState = 3;
				}

				this.updateHistory();
			}
		}
		else
		{
			this.vibrate(gamepad);
		}
	}

	_onAnswerClick(actionId: string, gamepad: Gamepad, isRed: boolean)
	{
		if (this._events.length
			 && (isRed && this._RedCurrentEventState == 3 || !isRed && this._BlueCurrentEventState == 3))
		{
			let lastEvent = this._findLastEventByAthlete(isRed);
			if (lastEvent)
			{
				lastEvent.Answer = actionId;
				this._resetEventState(isRed);

				this.updateHistory();
			}
		}
		else
		{
			this.vibrate(gamepad);
		}
	}

	_onKnockdownClick(actionId: string, gamepad: Gamepad, isRed: boolean)
	{
		if (this._events.length && !this._GroundStarted
			 && (isRed && this._RedCurrentEventState == 3 || !isRed && this._BlueCurrentEventState == 3))
		{
			//this._startGround();

			let lastEvent = this._findLastEventByAthlete(isRed);
			if (lastEvent)
			{
				lastEvent.Answer = 'Knockdown';
				//lastEvent.GroundStart = this._GroundStarted;

				this._resetEventState(isRed);
				this.updateHistory();
			}
		}
		else
		{
			this.vibrate(gamepad);
		}
	}

	_onTakedownClick(ev: MMAEvent, actionId: string, isSuccess: boolean, gamepad: Gamepad, isRed: boolean)
	{
		if (!this._GroundStarted
			 && (isRed && this._RedCurrentEventState == 1 || !isRed && this._BlueCurrentEventState == 1))
		{
			ev.Action = actionId;
			if (isSuccess)
			{
				this._startGround();
				ev.Answer = 'Hit';
				ev.GroundStart = this._GroundStarted;
			}
			else
			{
				ev.Answer = 'Miss'
			}

			this._addMMAEvent(ev);
			this._resetEventState(isRed);


			if (isSuccess)
				this.addControlHitEvent(isRed);		//1. тута надо добавить событие Control Hit если isSuccess

			this.updateHistory();
		}
		else
		{
			this.vibrate(gamepad);
		}
	}

	addControlHitEvent(isRed: boolean)
	{
		let controlEv = this._getEventByAthlete(isRed)

		let label = (isRed ? this._leftPadLabels : this._rightPadLabels).find(it => it.getData() == 'Control')

		this._startGrapple(controlEv, label, isRed);
	}

	_onGroundClick(gamepad: Gamepad, isRed: boolean)
	{
		if (isRed && this._RedCurrentEventState == 1 || !isRed && this._BlueCurrentEventState == 1)
		{
			let isStarted = this._GroundStarted;
			if (!isStarted)
				this._startGround();
			else
				this._endGround();

			this._resetEventState(isRed);

			if (!isStarted)
				this.addControlHitEvent(isRed);		//2.  тута надо добавить событие Contorl Hit

			this.updateHistory();

		}
		else
		{
			this.vibrate(gamepad);
		}
	}

	_startGround()
	{
		if (this._GrappleStarted)
			this._endGrapple();

		this._GroundStarted = this.getFormattedCurrentRoundTime();
		this._CurrentPosition = 'Ground';
		this._leftPadLabels.find(lbl => lbl.getRK() == 'Ground').setContent('-Gro');
		this._rightPadLabels.find(lbl => lbl.getRK() == 'Ground').setContent('-Gro');
		this.trySendMeta(this.getBattleEditMeta(), 3);
	}

	async _endGround()
	{
		let grappleStarted = this._GrappleStarted
		if (grappleStarted)
			this._endGrapple(false);

		let groundEnded = this.getFormattedCurrentRoundTime();

		this._events.forEach(ev =>
		{
			if (ev.GroundStart && !ev.GroundEnd)
				ev.GroundEnd = groundEnded;
		});

		this._GroundStarted = null;
		this._CurrentPosition = 'Distance';
		this.trySendMeta(this.getBattleEditMeta(), 3);

		if (grappleStarted)
			await ServerAPI.post(`/mma/setGroundGrappleEnd/${this._Battle.Id}?round=${this._Round}&end=${'00:' + groundEnded}`)
		else
			await ServerAPI.post(`/mma/setGroundEnd/${this._Battle.Id}?round=${this._Round}&groundEnd=${'00:' + groundEnded}`)


		this._leftPadLabels.find(lbl => lbl.getData() == 'Ground').setContent('+Gro');
		this._rightPadLabels.find(lbl => lbl.getData() == 'Ground').setContent('+Gro');

		this.updateHistory();
	}

	async _onControlClick(ev: MMAEvent, label: Label, gamepad: Gamepad, isRed: boolean)
	{
		if (this._GrappleStarted && this._isRedGrappleStarted != isRed) //Если один боец инициировал удержание, а второй в это время нажимает на старт удержания - вибрировать оба джойстика
		{
			//3. контроль должен переходить к другому и надо этому другому добавить Control Hit
			await this.endGrappleAsync();
			this._startGrapple(ev, label, isRed);
			this._resetEventState(isRed);
			this.updateHistory();
			return;
		}

		if (isRed && this._RedCurrentEventState == 1 || !isRed && this._BlueCurrentEventState == 1)
		{
			if (!this._GrappleStarted)
				this._startGrapple(ev, label, isRed);
			else
			{
				if (this._GroundStarted)
				{
					this.vibrate(gamepad);
					return;
				}

				this._endGrapple();
			}

			this._resetEventState(isRed);
			this.updateHistory();
		}
		else
		{
			this.vibrate(gamepad);
		}
	}

	_startGrapple(ev: MMAEvent, label: Label, isRed: boolean)
	{
		this._isRedGrappleStarted = isRed;
		this._GrappleStarted = this.getFormattedCurrentRoundTime();
		ev.Action = 'Control';
		ev.Answer = 'Hit';
		ev.GrappleStart = this._GrappleStarted;
		this._addMMAEvent(ev);

		label.setContent('-Con');

		this.trySendMeta(this.getBattleEditMeta(), 3);
	}

	_endGrapple(sendData: boolean = true)
	{
		this._GrappleStarted = null;
		if (sendData)
			this.trySendMeta(this.getBattleEditMeta(), 3);

		let grappleEnded = this.getFormattedCurrentRoundTime();

		this._events.forEach(ev =>
		{
			if (ev.GrappleStart && !ev.GrappleEnd)
				ev.GrappleEnd = grappleEnded;
		});

		if (sendData)
			ServerAPI.post(`/mma/setGrappleEnd/${this._Battle.Id}?round=${this._Round}&grappleEnd=${'00:' + grappleEnded}`)
				 .then(() =>
				 {
					 this.updateHistory();
				 });

		let labels = this._isRedGrappleStarted ? this._leftPadLabels : this._rightPadLabels;
		let controlLabel = labels.find(lbl => lbl.getRK() == 'Control');
		if (controlLabel)
			controlLabel.setContent('+Con');
	}

	async endGrappleAsync()
	{
		this._GrappleStarted = null;

		await	this.trySendMeta(this.getBattleEditMeta(), 3);

		let grappleEnded = this.getFormattedCurrentRoundTime();

		this._events.forEach(ev =>
		{
			if (ev.GrappleStart && !ev.GrappleEnd)
				ev.GrappleEnd = grappleEnded;
		});


		await ServerAPI.post(`/mma/setGrappleEnd/${this._Battle.Id}?round=${this._Round}&grappleEnd=${'00:' + grappleEnded}`)
		this.updateHistory();

		let labels = this._isRedGrappleStarted ? this._leftPadLabels : this._rightPadLabels;
		let controlLabel = labels.find(lbl => lbl.getRK() == 'Control');
		if (controlLabel)
			controlLabel.setContent('+Con');
	}


	startRound()
	{
		this._Battle.EndTime = null
		this._resetEventState();
		let roundStartDate = new Date();
		this._PauseLength = 0;
		this._RoundStarted = roundStartDate.getTime();
		this.trySendMeta({battleId: this._Battle.Id, isRoundStarted: false}, 3, //на случай если по этому бою предыдущий ввод данных был завершен некорректно
			 () => this.trySendMeta(this.getBattleEditMeta(), 3));
	}

	checkGamePad(gamepad: Gamepad, labels: Label[], isRed: boolean)
	{
		let clickedLabel = null;
		labels.forEach(lbl => lbl.getRoot().style.color = '');

		// if (this._blueCurrentEvent && isRed || this._redCurrentEvent && !isRed)
		// 	return;

		for (let i = 0; i < gamepad.buttons.length; i++)
		{
			let val = gamepad.buttons[i] as any,
				 pressed = val == 1.0;
			if (typeof (val) == "object")
			{
				pressed = val.pressed;
				val = val.value;
			}
			let lbl = labels.find(lbl => lbl.getValue() == i);
			if (lbl)
			{
				lbl.getRoot().style.color = pressed ? 'blue' : '';
				if (pressed)
				{
					clickedLabel = lbl;
					break;
				}
			}
		}

		if (clickedLabel == null)
		{
			let pressedAxes: GamepadAxisValues = [];
			for (let j = 0; j < gamepad.axes.length; j++)
			{
				let p = gamepad.axes[j];
				if (p > pressedAxisValue || p < -pressedAxisValue)
					pressedAxes.push({axis: j, value: p});
			}

			//для уменьшения "люфта" у нажатий вправо/влево, если ни по одной из осей нет полного нажатия, считать что действие не введено
			if (!pressedAxes.find(axis => axis.value > fullPressedAxisValue || axis.value < -fullPressedAxisValue))
				return;

			//округляем, чтобы точно определить нажатие аналога по целым значениям: -1, 0, 1
			pressedAxes.forEach(axis => axis.value = Math.round(axis.value));

			let lbl = labels
				 .filter(lbl => lbl.getData() == 'IsZone' || lbl.getData() == 'IsSubmission')
				 .sort((a, b) => -(a.getValue().length - b.getValue().length)) //диагонали обрабатывать первыми, чтобы лучше различать их от обычных вправо/влево
				 .find(lbl =>
				 {
					 //найти лэйбл по текущим нажатым axes (массив pressedAxes)
					 let axesValues: GamepadAxisValues = lbl.getValue();
					 if (axesValues.length != pressedAxes.length)
						 return false;

					 let axesEqual = true;
					 pressedAxes.forEach(pressedAxis =>
					 {
						 if (!axesValues.find(axisVal => axisVal.axis == pressedAxis.axis && axisVal.value == pressedAxis.value))
							 axesEqual = false;
					 });

					 return axesEqual;
				 });
			if (lbl)
			{
				lbl.getRoot().style.color = 'blue';
				clickedLabel = lbl;
			}
		}

		if (clickedLabel)
		{
			if (clickedLabel == (isRed ? this._redActiveButton : this._blueActiveButton))
			{
				if (!this._CanClickOneButton)
					return;

				let lastGamePadChecked = isRed ? this._RedGamePadeChecked : this._BlueGamePadeChecked;

				if (!lastGamePadChecked)
				{
					if (isRed)
						this._RedGamePadeChecked = (new Date()).getTime();
					else
						this._BlueGamePadeChecked = (new Date()).getTime();
					return;
				}

				lastGamePadChecked = isRed ? this._RedGamePadeChecked : this._BlueGamePadeChecked;

				let dif = (new Date()).getTime() - lastGamePadChecked;

				if (dif < 200)
				{
					if (isRed)
						this._RedGamePadeChecked = (new Date()).getTime();
					else
						this._BlueGamePadeChecked = (new Date()).getTime();

					if (this._checkButtonHold())
						this._onGamePadHold(gamepad, clickedLabel, isRed);

					return;
				}
			}

			this._resetButtonHold();

			if (isRed)
				this._redActiveButton = clickedLabel;
			else
				this._blueActiveButton = clickedLabel;

			this._onGamePadClick(gamepad, clickedLabel, isRed);
			if (isRed)
				this._RedGamePadeChecked = (new Date()).getTime();
			else
				this._BlueGamePadeChecked = (new Date()).getTime();
		}
	}

	_checkButtonHold(): boolean
	{
		if (this._PressedButtonChecked && ((new Date()).getTime() - this._PressedButtonChecked > 500))
			return true;

		if (!this._PressedButtonChecked)
			this._PressedButtonChecked = (new Date()).getTime();
		return false;
	}

	_resetButtonHold()
	{
		this._ButtonHoldProcessed = false;
		this._PressedButtonChecked = null;
	}

	updateStatus()
	{
		if (!this.isLive())
			return;

		let gamepads = [];

		for (let gamepad of navigator.getGamepads())
		{
			if (gamepad && gamepad.id.indexOf('Xbox') > -1)
				gamepads.push(gamepad);
		}

		if (gamepads[0])
			this.checkGamePad(gamepads[0], this._leftPadLabels, true);

		if (gamepads[1])
			this.checkGamePad(gamepads[1], this._rightPadLabels, false);

		setTimeout(() => this.updateStatus(), 50);
	}

	_getEventByAthlete(isRed: boolean)
	{
		let ev: MMAEvent;
		if (isRed)
		{
			this._redCurrentEvent = {
				BattleId: this._Battle.Id,
				Round: this._Round,
				ActionAthleteId: this._Battle.Red,
				AnswerAthleteId: this._Battle.Blue
			} as any;
			this._blueCurrentEvent = null;
			ev = this._redCurrentEvent;
		}
		else
		{
			this._blueCurrentEvent = {
				BattleId: this._Battle.Id,
				Round: this._Round,
				ActionAthleteId: this._Battle.Blue,
				AnswerAthleteId: this._Battle.Red,
			} as any;
			this._redCurrentEvent = null;
			ev = this._blueCurrentEvent;
		}

		return ev;
	}

	_findLastEventByAthlete(isRed: boolean): MMAEvent
	{
		if (this._events.length > 0)
		{
			let athleteEventsIndexes: number[] = [];
			this._events.forEach((ev, index) =>
			{
				if (ev.ActionAthleteId == (isRed ? this._Battle.Red : this._Battle.Blue))
					athleteEventsIndexes.push(index);
			});
			if (athleteEventsIndexes.length > 0)
				return this._events[athleteEventsIndexes[athleteEventsIndexes.length - 1]];
		}

		return null;
	}

	getBattleEditMeta(): BattleEditMeta
	{
		let isRedGrapple = this._GrappleStarted != null ? this._isRedGrappleStarted : undefined;

		return {
			battleId: this._Battle.Id,
			isRoundStarted: !!this._RoundStarted,
			round: this._Round,
			isPauseStarted: this._IsPause,
			pauseLen: this._PauseLength,
			ground: this._GroundStarted != null,
			grapple: this._GrappleStarted != null,
			isRedGrapple: isRedGrapple
		}
	}
}
